export const PROCESSING_TYPES = ["whitespace", "uploadedAccounts"] as const;
export const STORAGE_KEY_PREFIX = "matchdata_processing_";
export const INSTALL_FILTERS_STORAGE_KEY = "companyInstallsFilter";
export const INTENT_FILTERS_STORAGE_KEY = "market-analyzer-intent-filters";
